import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Form } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
// import funciones from '../../middleware/funciones';
import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import ModalCompanyModules from '../subcomponent/companyModuleModal';
import BackButton from '../widgets/back_button';

class CompanyConfigModule extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        //const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            datos: [],
            empresa: currentCompany,
            search: "",
            mostrarMensaje: false,
            mensaje: ""
        };
    }
    componentDidMount() {
        this.init();
    }

    init = () => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa
            }
        };
        fetch(config.servBackEnd + '/companies/', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({ datos });
                } else {
                    //console.log(data.message);
                }
            });
    }
    render() {
        const dato = (this.state.datos) ? this.state.datos : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        const { search } = this.state;
        return (

            <div className="contenedor">

                <div>
                    <Jumbotron style={style}>
                        <h1>Administrar Empresas</h1>
                    </Jumbotron>
                    <BackButton />
                    <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Control value={search} onChange={(e) => this.setState({ search: e.target.value })} type="text" placeholder="Search" />
                    </Form.Group>
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Nombre Empresa</th>
                            </tr>
                        </thead>
                        <tbody>

                            {dato.map(function (currentData, index) {
                                if (currentData.ID_EMPRESA.toLowerCase().search(search.toLowerCase()) > -1
                                    || currentData.RAZON_SOCIAL.toLowerCase().search(search.toLowerCase()) > -1) {
                                    return <tr key={index + "d0"}>
                                        <td>{currentData.ID_EMPRESA}</td>
                                        <td>{currentData.RAZON_SOCIAL}</td>
                                        <td><ModalCompanyModules company_name={currentData.RAZON_SOCIAL} company_code={currentData.ID_EMPRESA} /></td>
                                    </tr>;
                                } else {
                                    return null;
                                }
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>




        );
    }
}
export default (CompanyConfigModule);


// WEBPACK FOOTER //
// ./src/components/configuracion/empresagroupmodule.jsx